import { formatMoney, formatMoneyAmount } from '@/lib/format-money'

interface MoneyProps {
  amount: number | string | null | undefined
  currency?: string
  className?: string
}

/** Whole-dollar display with tabular numerals (NFR-12). */
export function Money({ amount, currency = 'USD', className = '' }: MoneyProps) {
  const formatted = formatMoney(amount, currency)
  const wholeLabel = formatMoneyAmount(amount)
  const title =
    amount == null || amount === '' ? undefined : `${currency} ${wholeLabel} (whole dollars)`

  return (
    <span className={`money ${className}`.trim()} title={title}>
      {formatted}
    </span>
  )
}
